import React from "react";
import { NotificationWrapper } from "./Notification.less";

const Notification = (props) => <div className="NotificationWrapper">{props.children}</div>;

export default Notification;
